import { module } from 'modujs';
import LocomotiveScroll from 'locomotive-scroll';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        setTimeout(() => {
            this.scroll = new LocomotiveScroll({
                el: this.el,
                smooth: true,
                offset: ['15%']
            });

            this.scroll.on('call', (func,way,obj,id) => {
                // Using modularJS
                this.call(func[0],{way,obj},func[1],func[2]);
            });

            this.pageHeaderOverlayTween = gsap.fromTo(
                document.querySelector('[data-scroll-id="pageHeaderOverlay"]'),
                1,
                {
                    alpha: -3
                },
                {
                    alpha: 1
                }
            );

            this.pageHeaderOverlayTween.pause();

            // Get all current elements : args.currentElements
            if(typeof this.scroll.scroll.currentElements['pageHeaderOverlay'] === 'object') {
                let progress = this.scroll.scroll.currentElements['pageHeaderOverlay'].progress;
                // console.log(progress);
                this.pageHeaderOverlayTween.progress(progress);
            }

            this.scroll.on('scroll', (args) => {
                // console.log(args.scroll);
                if(args.scroll.y > 50) {
                    html.classList.add('has-scrolled');
                } else {
                    html.classList.remove('has-scrolled');
                }

                // Get all current elements : args.currentElements
                if(typeof args.currentElements['pageHeaderOverlay'] === 'object') {
                    let progress = args.currentElements['pageHeaderOverlay'].progress;
                    // console.log(progress);
                    this.pageHeaderOverlayTween.progress(progress);
                }
            })
        }, 1100)
    }

    toggleLazy(args) {
        let src = this.getData('lazy', args.obj.el)
        if(src.length) {
            if(args.obj.el.tagName == "IMG") {
                args.obj.el.src = src
            } else {
                args.obj.el.style.backgroundImage = `url(${src})`
            }
            this.setData('lazy', '', args.obj.el)
        }
    }

    update() {
        if(this.scroll && this.scroll.update)
            this.scroll.update()
    }

    scrollTo(args) {
        this.scroll.scrollTo(args);
    }

    destroy() {
        this.scroll.destroy();
    }
}
